var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "has-bottom" },
    [
      _c(
        "div",
        { staticClass: "page-main " },
        [
          _c("page-title"),
          _vm._v(" "),
          _c(
            "page-card",
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c("span", [_vm._v("To :")]),
                  _vm._v(" "),
                  +_vm.$store.getters.userInfo.type === 0
                    ? _c(
                        "el-select",
                        {
                          staticClass: "username-select",
                          staticStyle: { width: "3.8rem" },
                          attrs: { placeholder: "Please fill in" },
                          model: {
                            value: _vm.username,
                            callback: function ($$v) {
                              _vm.username = $$v
                            },
                            expression: "username",
                          },
                        },
                        _vm._l(_vm.optionsManger, function (item) {
                          return _c("el-option", {
                            key: item.username,
                            attrs: {
                              label: item.username,
                              value: item.username,
                            },
                          })
                        }),
                        1
                      )
                    : _c(
                        "el-select",
                        {
                          staticClass: "username-select",
                          attrs: {
                            filterable: "",
                            remote: "",
                            "reserve-keyword": "",
                            placeholder: "Please fill in",
                            "remote-method": _vm.remoteMethod,
                            loading: _vm.loadingSelect,
                          },
                          model: {
                            value: _vm.username,
                            callback: function ($$v) {
                              _vm.username = $$v
                            },
                            expression: "username",
                          },
                        },
                        _vm._l(_vm.options, function (item) {
                          return _c("el-option", {
                            key: item.recipientName,
                            attrs: {
                              label: item.recipientName,
                              value: item.recipientName,
                            },
                          })
                        }),
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title spaceLeft",
                      staticStyle: { "margin-bottom": "0.2rem" },
                    },
                    [
                      _c("span", { staticClass: "title" }, [
                        _vm._v("Subject :"),
                      ]),
                      _vm._v(" "),
                      _c("el-input", {
                        attrs: {
                          placeholder: "Please fill in",
                          maxlength: "200",
                        },
                        model: {
                          value: _vm.pageData.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageData, "title", $$v)
                          },
                          expression: "pageData.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        "Please enter a description within 1000 characters",
                      type: "textarea",
                      maxlength: "1000",
                    },
                    model: {
                      value: _vm.pageData.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.pageData, "description", $$v)
                      },
                      expression: "pageData.description",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "page-bottom",
        [
          [
            _c(
              "div",
              { staticClass: "page-btns" },
              [
                _c("el-button", { on: { click: _vm.goback } }, [
                  _vm._v("Cancel"),
                ]),
                _vm._v(" "),
                _c("loading-btn", {
                  attrs: { type: "primary", label: "Submit" },
                  on: { clickHandle: _vm.submit },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }